import { Box, Button, Menu, MenuContent, MenuItem, MenuTrigger, Portal } from '@chakra-ui/react'
import { ChevronDownIcon } from '@editor/assets/icons'
import { DIAMETERS } from '@editor/config/constants'
import { INPUT_GROUP_STYLES } from '@editor/config/styles'
import { findDiameterKeyByValue } from '@editor/services/Util'
import { useAppDispatch } from '@editor/store/app'
import { toggleSelectedElementIds } from '@editor/store/tool'

import { DistanceLabelWorkingCylinderProps, updateWorkingLinesDiameterById } from '../store'

const DiameterSelection = ({ label }: { label: DistanceLabelWorkingCylinderProps }) => {
  // Store
  const dispatch = useAppDispatch()

  return (
    /* A wrapper container specifically for preventing bubbling up click events */
    <Box flex={1} onClick={(e) => e.stopPropagation()}>
      <Menu.Root variant="toolbar">
        <MenuTrigger asChild>
          <Button
            textAlign="left"
            fontWeight="normal"
            fontSize="xs"
            paddingX={2}
            marginLeft={1}
            height={7}
            width="100%"
            variant="toolbar"
            {...INPUT_GROUP_STYLES}
          >
            {label.diameter ? `${findDiameterKeyByValue(label.diameter)}（${label.diameter || ''}）` : ''}
            <ChevronDownIcon />
          </Button>
        </MenuTrigger>
        <Portal>
          <MenuContent maxHeight={{ base: '70vh', xl: '50vh' }} overflowY="auto">
            {Object.keys(DIAMETERS).map((d) => (
              <MenuItem
                key={d}
                value={d}
                backgroundColor={label.diameter === DIAMETERS[d] ? 'secondary.600' : 'transparent'}
                onClick={() => {
                  dispatch(updateWorkingLinesDiameterById({ id: label.id, diameter: DIAMETERS[d] }))
                  dispatch(toggleSelectedElementIds({ ids: [label.id], selected: false }))
                }}
                fontSize="xs"
              >
                {d}（{DIAMETERS[d]}）
              </MenuItem>
            ))}
          </MenuContent>
        </Portal>
      </Menu.Root>
    </Box>
  )
}

export default DiameterSelection
